module.exports = __webpack_public_path__ + "img/drop-grey-sm.25ec2ee5.svg";